import { JsonObject } from '@/lib/helpers';

export class TelemetrySyncStates {
  userEvents: TelemetrySyncState;
  auditEvents: TelemetrySyncState;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof TelemetrySyncStates, unknown>;

    this.userEvents = new TelemetrySyncState(data.userEvents as JsonObject);
    this.auditEvents = new TelemetrySyncState(data.auditEvents as JsonObject);
  }
}

export class TelemetrySyncState {
  consecutiveFailureCount: number;
  lastSyncedAt: string; // <datetime>,
  lastSyncedEventId: string; //<object id>,
  lastSyncedEventTimestamp: number; //<timestamp>

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof TelemetrySyncState, unknown>;

    this.consecutiveFailureCount = (data.consecutiveFailureCount as number) || 0;
    this.lastSyncedAt = (data.lastSyncedAt as string) || '';
    this.lastSyncedEventId = (data.lastSyncedEventId as string) || '';
    this.lastSyncedEventTimestamp = (data.lastSyncedEventTimestamp as number) || 0;
  }
}
